// Gallery photos — Tamara's real work from Instagram + salon
export const galleryItems = [
  // Balayage — real Tamara photos
  {
    id: "g47",
    category: "Balayage",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/5n2ie0h4_imgi_47_553364433_18307281532216592_1332294082095382365_n.jpg",
    alt: "Balayage chocolate com reflexos de caramelo",
    featured: true,
  },
  {
    id: "g2",
    category: "Balayage",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/aabfwl1e_imgi_19_684108728_960404556464635_2529809636238793239_n.jpg",
    alt: "Balayage caramelo iluminado",
  },
  {
    id: "g4",
    category: "Balayage",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/rbe0gu3w_imgi_21_656573479_18330413905216592_8355714492754295250_n.jpg",
    alt: "Balayage loiro mel",
  },
  {
    id: "g14",
    category: "Balayage",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/6klew0kj_imgi_30_607894485_896497549561124_1570676240917161407_n.jpg",
    alt: "Balayage castanho com ondas suaves",
  },
  {
    id: "g15",
    category: "Balayage",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/saa76v0e_imgi_35_592436592_18316934593216592_2386849543561521754_n.jpg",
    alt: "Balayage iluminado com ondas",
  },
  {
    id: "g16",
    category: "Balayage",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/c4bqfzll_imgi_36_587808709_18316933813216592_23930970765505157_n.jpg",
    alt: "Balayage loiro mel iluminado",
  },
  {
    id: "g41",
    category: "Balayage",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/415sct0z_imgi_41_581499473_1205289778194997_71145856557692178_n.jpg",
    alt: "Balayage loiro dourado com ondas",
  },
  {
    id: "g42",
    category: "Balayage",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/nsewuw31_imgi_42_583208714_18316002076216592_2611327928488649602_n.jpg",
    alt: "Balayage loiro mel natural",
  },

  // Coloração / Madeixas
  {
    id: "g3",
    category: "Coloração",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/iyffmp9j_imgi_20_657561443_26348764558126097_625908191108983566_n.jpg",
    alt: "Coloração profissional",
  },
  {
    id: "g13",
    category: "Coloração",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/2oitfcf5_imgi_24_642138744_1230983702566729_6463080894818792200_n.jpg",
    alt: "Madeixas com papel de prata",
  },

  // Bastidores
  {
    id: "g38",
    category: "Bastidores",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/31tzjdrd_imgi_38_587946409_2565243837194270_334227677156653519_n.jpg",
    alt: "Tamara a finalizar um penteado",
  },
  {
    id: "g39",
    category: "Bastidores",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/uxi8c03u_imgi_39_589082401_1516839019569575_5183413985946423852_n.jpg",
    alt: "Tamara a trabalhar com produtos Cotril",
  },
  {
    id: "g46",
    category: "Bastidores",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/zu9spgfk_imgi_46_560089235_1137996458433022_1217392210076681014_n.jpg",
    alt: "Resultado final no espelho do estúdio",
  },

  // Estúdio
  {
    id: "g43",
    category: "Estúdio",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/yllih0wa_imgi_43_580481527_1318441866264310_7541764180597109292_n.jpg",
    alt: "Linha completa Cotril no estúdio",
  },
  {
    id: "g44",
    category: "Estúdio",
    src: "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/tcoj81un_imgi_44_567991897_1336542328261889_1419270928657984171_n.jpg",
    alt: "Montra do estúdio Tamara Alves Hairstylist",
  },
];

export const galleryCategories = [
  "Todos",
  "Balayage",
  "Coloração",
  "Bastidores",
  "Estúdio",
];

// Salon photos as constants for use in pages
export const SALON_EXTERIOR =
  "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/893u7neo_imgi_23_654653366_18329424478216592_3136637934024010232_n.jpg";

export const SALON_EXTERIOR_2 =
  "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/tcoj81un_imgi_44_567991897_1336542328261889_1419270928657984171_n.jpg";

export const SALON_INTERIOR_COTRIL =
  "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/yllih0wa_imgi_43_580481527_1318441866264310_7541764180597109292_n.jpg";

export const TAMARA_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/uisk7hh5_imgi_45_561525332_673730422456912_8958745016207556872_n.jpg";

export const MIRROR_CLIENT =
  "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/zu9spgfk_imgi_46_560089235_1137996458433022_1217392210076681014_n.jpg";

// Cotril + Brand "A" logo photo (used as Pre-Shop banner)
export const COTRIL_BRAND_HERO =
  "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/rjjvbg55_imgi_40_583895343_18316003360216592_3535083646176641336_n.jpg";

// Editorial portraits (studio shoot)
export const HOME_HERO =
  "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/obdyf2d9_imgi_15_621360849_18052639772444406_777881498293798081_n.jpg";

export const SOBRE_HERO =
  "https://customer-assets.emergentagent.com/job_tamara-balayage-pt/artifacts/wwevns8g_imgi_2_610811850_18320541598216592_6347266393794950994_n.jpg";
